export default {
    methods: {
        parseTextFromHTML(htmlString) {
            return htmlString.replace(/<[^>]+>/g, '') || '';
        },
    },
};
